import { View } from 'react-native';
import styled from 'styled-components/native';

import Card from '@components/Card';
import Text from '@components/Text';

export const Container = styled(Card)`
  max-height: 152.91px;
`;

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 23.92px;
`;

export const HeaderText = styled(Text)`
  font-size: 12px;
`;

export const HeaderCard = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ContainerCardIcon = styled(View)`
  width: 48px;
  height: 24px;
`;

export const HeaderCardText = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;
  margin-left: 8px;
`;

export const Limit = styled.View``;

export const LimitUsedText = styled(Text)`
  font-size: 18px;
  font-family: ${props => props.theme.fonts.weight[500]};
  color: ${props => props.color};
  margin-top: 8px;
`;

export const LimitBar = styled.View`
  margin: 16px 0px;
`;

export const LimitText = styled(Text)`
  text-align: right;
  font-size: 14px;
`;

export const LimitTotalText = styled(Text)`
  font-family: ${props => props.theme.fonts.weight[500]};
  font-size: 14px;
  margin-left: 3px;
`;
